interface ChatUnavailableProps {
  className?: string;
}

/**
 * What a chat surface shows while the companion is not allowed to be there.
 *
 * `isChatAvailable` is false for the length of a live self-assessment attempt
 * (ORA-449): the entry points are hidden, and a shell that is somehow already
 * on screen must not offer a composer either.
 */
const ChatUnavailable = ({ className = '' }: ChatUnavailableProps) => (
  <div
    role="status"
    className={`flex flex-1 items-center justify-center p-6 text-center text-sm text-fg-secondary ${className}`}
  >
    <p className="m-0 max-w-xs">
      Ora is unavailable during a self-assessment. It comes back when your
      attempt is over.
    </p>
  </div>
);

export default ChatUnavailable;
